import React from 'react';
import { LEVEL_PERCENTAGES, LEVEL_RANKS, LEVEL_RANK_COLORS } from '../../config/contract';
import { formatUSDT } from '../../utils/format';

const LevelEligibility = ({ eligibility, counts, volumes, requirements }) => {
  return (
    <div className="level-grid">
      {LEVEL_PERCENTAGES.map((pct, i) => {
        const isEligible = eligibility && eligibility[i];
        const req = (requirements && requirements[i]) || { selfInvestment: '0', teamBusiness: '0', directReferrals: 0 };
        return (
          <div key={i} className={`level-card ${isEligible ? 'eligible' : ''}`}>
            <div className="level-num">Level {i + 1}</div>
            <div className="level-rank" style={{
              color: LEVEL_RANK_COLORS[i],
              textShadow: `0 0 12px ${LEVEL_RANK_COLORS[i]}80`
            }}>{LEVEL_RANKS[i]}</div>
            <div className="level-title">{pct}%</div>
            <div className="level-stats">
              <div className="level-stat-row">
                <span className="level-stat-label">Members</span>
                <span className="level-stat-value">{counts && counts[i] ? counts[i].toString() : '0'}</span>
              </div>
              <div className="level-stat-row">
                <span className="level-stat-label">Volume</span>
                <span className="level-stat-value">{volumes && volumes[i] ? formatUSDT(volumes[i]) : '0'}</span>
              </div>
              {i <= 8 && (
                <>
                  <div className="level-stat-row">
                    <span className="level-stat-label">Need Self</span>
                    <span className="level-stat-value">{formatUSDT(req.selfInvestment)}</span>
                  </div>
                  <div className="level-stat-row">
                    <span className="level-stat-label">Need Team</span>
                    <span className="level-stat-value">{formatUSDT(req.teamBusiness)}</span>
                  </div>
                </>
              )}
              <div className="level-stat-row">
                <span className="level-stat-label">Need Directs</span>
                <span className="level-stat-value">{req.directReferrals?.toString() || '0'}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LevelEligibility;
